export default __webpack_public_path__ + "static/media/place3.a4dc1136.jpeg";